import { render, staticRenderFns } from "./AppFlexGrid.vue?vue&type=template&id=41facfa5&scoped=true&"
import script from "./AppFlexGrid.vue?vue&type=script&lang=js&"
export * from "./AppFlexGrid.vue?vue&type=script&lang=js&"
import style0 from "./AppFlexGrid.vue?vue&type=style&index=0&id=41facfa5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41facfa5",
  null
  
)

export default component.exports